import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
export const AccountPermessi: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", data: [
        { type: 'campo', colVisible:false,visible:false, dataField: "id", dataType: ""},
        { type: 'campo', colVisible:false, visible:false, dataField: "idAccountPermessi", dataType: ""},
        { type: 'campo', colVisible:false,visible:false, dataField: "idMenuFunzioni", dataType: ""},
        { type: 'campo', colVisible:false,disableOnUpdate:true, hideOnEdit:true,visible:true, dataField: "macroMenu", dataType: ""},
        
        {
          type: "button",  caption: "", 
          button:             
                { name: 'Full', icon: 'checklist', hint: 'Controllo Completo', event: '1', location: 'top'},
        },


        { type: 'campo',disableOnUpdate:true, disabled:true,  hideOnEdit:true, dataField: "descrizioneuFunzioni", dataType: "", caption: "Funzione", width: "300" },
        { type: 'campo', dataField: "inserimento", dataType: "boolean"},
        { type: 'campo', dataField: "modifica", dataType: "boolean"},
        { type: 'campo', dataField: "cancellazione",dataType: "boolean" },
        { type: 'campo', dataField: "visualizzazione", dataType: "boolean",},
      ]
    },
  ]